"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldDisplayPasswordRequirementRed = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _iconCheck = _interopRequireDefault(require("../../../icons/icon-check.svg"));
var _iconPassErrorGrey = _interopRequireDefault(require("../../../icons/icon-pass-error-grey.svg"));
var _iconPassErrorRed = _interopRequireDefault(require("../../../icons/icon-pass-error-red.svg"));
const StyledPasswordRequirementText = _styled.default.div(_ref => {
  let {
    displayRequirementRed,
    hasBeenFocused,
    fieldIsDirty,
    meetsPasswordRequirements,
    theme
  } = _ref;
  const getHelperTextColor = () => {
    if (meetsPasswordRequirements) {
      return theme === null || theme === void 0 ? void 0 : theme.colors.success;
    }
    if (displayRequirementRed) {
      return theme === null || theme === void 0 ? void 0 : theme.colors.red;
    }
    return theme === null || theme === void 0 ? void 0 : theme.colors.grey[500];
  };
  return {
    display: hasBeenFocused || fieldIsDirty ? 'flex' : 'none',
    alignItems: 'center',
    color: getHelperTextColor(),
    fontSize: theme === null || theme === void 0 ? void 0 : theme.fontSizes.xxxSmall,
    fontWeight: theme === null || theme === void 0 ? void 0 : theme.fontWeights.medium,
    marginTop: '5px'
  };
});
const passwordRequirementTextIcon = _ref2 => {
  let {
    displayRequirementRed,
    passwordState
  } = _ref2;
  if (passwordState.meetsPasswordRequirements) {
    return _iconCheck.default;
  }
  if (displayRequirementRed) {
    return _iconPassErrorRed.default;
  }
  return _iconPassErrorGrey.default;
};

// Note: The methods that handle validation could be made simpler and easier to understand by using the "early return"
// pattern instead of combining lots of logical statements. We might also employ a state machine to help keep track
// of everything, using React's state/redux or possibly another utility.
const shouldDisplayPasswordRequirementRed = _ref3 => {
  let {
    errorMessageShown,
    fieldIsDirty,
    fieldIsFocused,
    meetsPasswordRequirements,
    hasBeenFocused,
    hasMetRequirementOnce
  } = _ref3;
  return errorMessageShown || !meetsPasswordRequirements && (!fieldIsFocused && hasBeenFocused && fieldIsDirty || hasMetRequirementOnce);
};
exports.shouldDisplayPasswordRequirementRed = shouldDisplayPasswordRequirementRed;
const PasswordRequirement = _ref4 => {
  let {
    errorMessageShown,
    fieldIsDirty,
    fieldIsFocused,
    passwordRequirementText,
    passwordState
  } = _ref4;
  const {
    meetsPasswordRequirements,
    hasBeenFocused,
    hasMetRequirementOnce
  } = passwordState;
  const displayRequirementRed = shouldDisplayPasswordRequirementRed({
    errorMessageShown,
    fieldIsDirty,
    hasBeenFocused,
    hasMetRequirementOnce,
    fieldIsFocused,
    meetsPasswordRequirements
  });
  return /*#__PURE__*/_react.default.createElement(StyledPasswordRequirementText, {
    displayRequirementRed: displayRequirementRed,
    errorMessageShown: errorMessageShown,
    fieldIsDirty: fieldIsDirty,
    fieldIsFocused: fieldIsFocused,
    hasBeenFocused: hasBeenFocused,
    hasMetRequirementOnce: hasMetRequirementOnce,
    meetsPasswordRequirements: meetsPasswordRequirements
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "success/error",
    src: passwordRequirementTextIcon({
      displayRequirementRed,
      passwordState
    }),
    style: {
      marginRight: '8px'
    }
  }), /*#__PURE__*/_react.default.createElement("span", null, passwordRequirementText));
};
var _default = exports.default = PasswordRequirement;